export const hospitalClinicalColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'cmg_code',
  'coder_name',
  'condition_code',
  'cost_outlier_threshold',
  'risk_of_mortality',
  'severity_of_illness',
];
